<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-collapse-item title="基础信息" name="1">
        <van-field v-model="inputForm.projectName" label="物业项目名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
		<van-field v-if="inputForm.resourceType == 1" v-model="inputForm.contractCode" label="合同编号" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-if="inputForm.resourceType == 2" v-model="inputForm.houseName" label="装修申请房间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.applicantTypeName" label="申请人类型" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.applicantName" label="装修申请人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.decorateStatusName" label="装修状态" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.decorateTypeName" label="装修方式" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.startDate" label="进场时间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.endDate" label="结束时间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.applicantPhone" label="联系方式" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.decorateDesc" rows="2" autosize label="详细描述" label-width="100px" type="textarea" readonly input-align="left" :border="false"/>
        <div style="padding-left: 16px;" v-show="inputForm.decorateAttachList.length > 0">
          <p>附件</p>
          <a style="display: block; color: #4caedc" v-for="file in inputForm.decorateAttachList" :href="file.url">{{file.name}}</a>
        </div>
      </van-collapse-item>
      <van-collapse-item title="装修房间明细" name="2">
        <div class="m-form" ref="scrollContainer">
			<div v-for="(data, index) in decorateHouseList" :key="index" style="margin-bottom: 10px" v-if="inputForm.resourceType == 1">
				<div class="m-row">
				  <div class="m-row-text">资源编号</div>
				  <div class="m-row-content">{{data.houseName}}</div>
				</div>
				<div class="m-row">
				  <div class="m-row-text">建筑面积(㎡)</div>
				  <div class="m-row-content">{{data.propertyArea}}</div>
				</div>
				<div class="m-row">
				  <div class="m-row-text">套内面积(㎡)</div>
				  <div class="m-row-content">{{data.inPropertyArea}}</div>
				</div>
            </div>
            <div v-for="(data, index) in decorateHouseList" :key="index" style="margin-bottom: 10px" v-if="inputForm.resourceType == 2">
				<div class="m-row">
				  <div class="m-row-text">物业类型</div>
				  <div class="m-row-content">{{ data.houseTypeName }}</div>
				</div>
				<div class="m-row">
				  <div class="m-row-text">房间名称</div>
				  <div class="m-row-content">{{data.buildingName + (data.buildingType === 3 ? "-" + data.unit : "") + "-" + data.code}}</div>
				</div>
				<div class="m-row">
				  <div class="m-row-text">产权人</div>
				  <div class="m-row-content">{{data.houseDeliveryDTO && data.houseDeliveryDTO.customerList.map(value => value.customerName).join()}}</div>
				</div>
				<div class="m-row">
				  <div class="m-row-text">产权面积（㎡）</div>
				  <div class="m-row-content">{{data.propertyArea}}</div>
				</div>
            </div>
        </div>
<!--        <div class="m-row" v-for="data in decorateHouseList">-->
<!--          <div>物业类型：{{data.houseTypeName}}</div>-->
<!--          <div>房间名称：{{data.buildingName + (data.buildingType === 3 ? "-" + data.unit : "") + "-" + data.code}}</div>-->
<!--          <div>-->
<!--            产权人：{{data.houseDeliveryDTO && data.houseDeliveryDTO.customerList.map(value => value.customerName).join()}}-->
<!--          </div>-->
<!--          <div>产权面积（㎡）：{{data.propertyArea}}</div>-->
<!--        </div>-->

      </van-collapse-item>
      <van-collapse-item title="装修公司信息" name="3" v-if="inputForm.decorateType === '2'">
        <van-field v-model="inputForm.companyName" label="装修公司名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.companyLiable" label="负责人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.companyPhone" label="联系方式" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.companyDesc" rows="2" autosize label="公司描述" label-width="100px" type="textarea" readonly input-align="left" :border="false"/>
        <div style="padding-left: 16px;" v-show="inputForm.companyAttachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.companyAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
<!--        <div style="padding-left: 20px;">-->
<!--          <p>附件</p>-->
<!--          <a style="display: block; color: #4caedc" :key="index" v-for="(file,index) in inputForm.companyAttachList" :href="file.url">{{file.name}}</a>-->
<!--        </div>-->
      </van-collapse-item>
      <van-collapse-item title="缴费明细" name="4">
        <div class="m-form" ref="scrollContainer">
          <div v-for="(data, index) in inputForm.receivableListDetail" :key="index" style="margin-bottom: 10px">
            <div class="m-row">
              <div class="m-row-text">收费标准名称</div>
              <div class="m-row-content large-content">{{ data.feeNormName }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">费用承担人</div>
              <div class="m-row-content large-content">{{data.customerName}}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">计费区间</div>
              <div class="m-row-content large-content">{{data.payStartingDate}} - {{ data.payDeadlineDate }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">应收金额(元)</div>
              <div class="m-row-content">{{data.amount}}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">备注</div>
              <div class="m-row-content large-content">{{data.remarks}}</div>
            </div>
          </div>
        </div>
<!--        <div class="m-row" v-for="data in inputForm.receivableListDetail" :key="data.id">-->
<!--          <div>收费标准名称：{{data.feeNormName}}</div>-->
<!--          <div>费用承担人：{{data.customerName}}</div>-->
<!--          <div>计费区间：{{data.payStartingDate}} - {{ data.payDeadlineDate }}</div>-->
<!--          <div>应收金额(元)：{{data.amount}}</div>-->
<!--          <div>备注：{{data.remarks}}</div>-->
<!--          <div>实收金额(元)：{{data.paymentAmount}}</div>-->
<!--          <div>已退金额(元)：{{data.refundAmount}}</div>-->
<!--        </div>-->
      </van-collapse-item>
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>
  
<script>
import DecorateService from '@/api/decorate/DecorateService.js'
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import processRecord from "../../components/processRecord/processRecord";
export default {
  data() {
    return {
      activeNames: ['1', '2', '3', '4'],
      isshow: false,
      inputForm: {
        id: '',
        projectId: '',
        projectName: '',
        decorateType: '2',
        applicantType: '1',
        houseId: '',
        houseName: '',
        applicantId: '',
        applicantName: '',
        applicantPhone: '',
        dateRange: [],
        startDate: '',
        endDate: '',
        decorateDesc: '',
        companyId: '',
        companyName: '',
        companyLiable: '',
        companyPhone: '',
        companyDesc: '',
        decorateStatus: '',
        isRectify: '',
        decorateAttachIds: [],
        decorateAttachList: [],
        companyAttachIds: [],
        companyAttachList: [],
        receivableListDetail: [],
        flowList: [],
        createDate: '',
        updateDate: '',
        createByName: '',
        applyMethod: '',
        planPeriod: '', // 巡检周期
        planUserName: '',//巡检责任人
        isDoTask: false,
        isLastTask: false
      },
      decorateHouseList: [],
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      layoutHeight: '0px',
      time: 0
    }
  },
  components: {
    processRecord
  },
  mounted() {
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      new DecorateService().queryById(id).then(({ data }) => {
        this.inputForm = data
        this.decorateHouseList = data.decorateHouseList;
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        //this.DecorateService.applyPass(_this.inputForm.id)
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          new DecorateService().startFlow({
            id: _this.inputForm.id,
            flowType: _this.inputForm.flowType,
            formKey: _this.inputForm.formKey
          });

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          new DecorateService().startFlow({
            id: _this.inputForm.id,
            flowType: _this.inputForm.flowType,
            formKey: _this.inputForm.formKey
          });

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.m-form {
  width: 100vw;
  padding: 10px;
  font-size: 12px;
  box-sizing: border-box;
}
.title {
  width: calc(100vw - 20px);
  height: 30px;
  background-color: #eeeeee;
  line-height: 30px;
  font-weight: bold;
  padding-left: 5px;
  box-sizing: border-box;
  /*// margin-bottom: 20rpx;*/
}

.m-row {
  display: flex;
  width: calc(100vw - 22px);
  border: 1px solid #eee;
  border-bottom: 0px;
}

.m-row-text {
  width: 110px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  /*border-bottom: 1px solid #eee;*/
  display: flex;
  align-items: center;
  /*background-color: #eee;*/
}

.m-row-content {
  width: calc(100vw - 130px);
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}

.large-content {
  width: calc(100vw - 130px);
  min-height: 30px;
  height: auto;
  padding-left: 10px;
  overflow: hidden;
}
</style>
  